import {css} from 'styled-components';
import {fontWeightTokens} from "../../tokens/fontWeight";

export const DefaultTextStyleCss = css`
  font-family: 'Euclid Circular A', sans-serif;
  font-style: normal;
  font-weight: ${fontWeightTokens.regular};
`;
